export const pickKeysFromObject = <T, K extends keyof T>(obj: T, keysToPick: K[]): Pick<T, K> => {
  return keysToPick.reduce(
    (acc, key) => {
      acc[key] = obj[key];
      return acc;
    },
    {} as Pick<T, K>,
  );
};
